import * as React from "react";

export const Article = ({ children }) => (
    <p className="mb-2 leading-7 tracking-wide flex-grow-0">{children}</p>
);
